import { render, staticRenderFns } from "./SelectChildDialog.vue?vue&type=template&id=fae2a800&scoped=true"
import script from "./SelectChildDialog.vue?vue&type=script&lang=js"
export * from "./SelectChildDialog.vue?vue&type=script&lang=js"
import style0 from "./SelectChildDialog.vue?vue&type=style&index=0&id=fae2a800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae2a800",
  null
  
)

export default component.exports